module.exports = __webpack_public_path__ + "img/noData.021a30c3.jpg";